import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";

var _this = this;

import { eventBus } from "~/abstractions/event-bus";

export default (function (_ref, inject) {
  var app = _ref.app,
      store = _ref.store,
      redirect = _ref.redirect,
      res = _ref.res;

  eventBus.$on("logout", _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!process.client) {
              _context.next = 3;
              break;
            }

            _context.next = 3;
            return app.$swal("Sesión Terminada", "Por favor vuelva a ingresar al sistema", "info");

          case 3:
            if (!(process.server && res.headersSent)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:

            store.$removeAuthCookie();
            _context.next = 8;
            return store.dispatch("user/cleanUserData");

          case 8:
            redirect("/");
            console.log("Si llega hasta aki");

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  })));
});


//////////////////
// WEBPACK FOOTER
// ./src/plugins/on-logout.js
// module id = ./src/plugins/on-logout.js
// module chunks = 34